/**
 * Live balance hook — single source of truth for the user's USD
 * balance across the app.
 *
 * `useMe` returns the snapshot of `users.balance` at the time of
 * /web/api/me, which is cached 60 s and not invalidated by anything
 * other than a successful pay_order. The header and the Balance page
 * both subscribe via this hook so the value they display always
 * matches — React Query deduplicates the request on the shared
 * `["balance"]` key.
 */

import { useQuery } from "@tanstack/react-query";

import { api, ApiError } from "./client";

export interface BalanceResponse {
  balance: string;
}

export function useBalance() {
  return useQuery<BalanceResponse, ApiError>({
    queryKey: ["balance"],
    queryFn: () => api.get<BalanceResponse>("/web/api/balance"),
    refetchInterval: 15_000,
    staleTime: 5_000,
  });
}
